/**
 * Shop Categories — dual-layout handler.
 * Runs whichever layout is present on the page:
 *   • #categories-accordion      → v1 accordion behavior
 *   • [data-shop-categories]     → v2 editorial-split behavior (numbered nav + crossfade)
 */
(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════
     v1 — ACCORDION LAYOUT
     Hover/click/keyboard nav expands a panel, collapses others.
  ════════════════════════════════════════════════════════════ */
  (function initAccordion() {
    var container = document.getElementById('categories-accordion');
    if (!container) return;

    var panels = container.querySelectorAll('.category-panel');
    var activeIndex = 0;

    function activatePanel(index) {
      if (activeIndex === index) return;
      activeIndex = index;

      panels.forEach(function (p, i) {
        var overlay = p.querySelector('.category-overlay');
        var collapsed = p.querySelector('.category-collapsed');
        var expanded = p.querySelector('.category-expanded');

        if (i === index) {
          p.style.flex = '4';
          p.setAttribute('aria-expanded', 'true');
          p.classList.add('shadow-card-lift');
          if (overlay) {
            overlay.classList.remove('bg-black/35');
            overlay.classList.add('bg-black/0');
          }
          if (collapsed) {
            collapsed.classList.remove('opacity-100');
            collapsed.classList.add('opacity-0');
          }
          if (expanded) {
            expanded.classList.remove('opacity-0', 'translate-y-4');
            expanded.classList.add('opacity-100', 'translate-y-0');
          }
        } else {
          p.style.flex = '0.8';
          p.setAttribute('aria-expanded', 'false');
          p.classList.remove('shadow-card-lift');
          if (overlay) {
            overlay.classList.remove('bg-black/0');
            overlay.classList.add('bg-black/35');
          }
          if (collapsed) {
            collapsed.classList.remove('opacity-0');
            collapsed.classList.add('opacity-100');
          }
          if (expanded) {
            expanded.classList.remove('opacity-100', 'translate-y-0');
            expanded.classList.add('opacity-0', 'translate-y-4');
          }
        }
      });
    }

    /* The whole panel is the click target, not just the Explore link. A panel
       that is not yet open takes the first interaction to open it, so on touch
       the first tap expands and the second follows the link. Pointers that can
       hover have already expanded it by then, so one click navigates. */
    function followPanel(panel) {
      var href = panel.getAttribute('data-panel-href');
      if (!href || href === '#') return false;
      window.location.href = href;
      return true;
    }

    panels.forEach(function (panel, index) {
      panel.addEventListener('mouseenter', function () { activatePanel(index); });
      panel.addEventListener('click', function (e) {
        // Let the Explore link, or anything else clickable inside, behave normally.
        if (e.target.closest('a')) return;
        if (activeIndex === index) {
          followPanel(panel);
        } else {
          activatePanel(index);
        }
      });

      panel.setAttribute('tabindex', '0');
      panel.setAttribute('role', 'link');
      panel.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (activeIndex === index) {
            followPanel(panel);
          } else {
            activatePanel(index);
          }
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = (index + 1) % panels.length;
          panels[next].focus();
          activatePanel(next);
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = (index - 1 + panels.length) % panels.length;
          panels[prev].focus();
          activatePanel(prev);
        }
      });
    });
  })();

  /* ════════════════════════════════════════════════════════════
     v2 — EDITORIAL SPLIT LAYOUT
     Numbered nav drives crossfading hero image + caption swap.
  ════════════════════════════════════════════════════════════ */
  (function initEditorial() {
    var root = document.querySelector('[data-shop-categories]');
    if (!root) return;

    var buttons = root.querySelectorAll('[data-sc-index]');
    var photos = root.querySelectorAll('[data-sc-photo]');
    var captions = root.querySelectorAll('[data-sc-caption]');
    var counter = root.querySelector('[data-current-index]');
    if (!buttons.length) return;

    var activeIndex = 0;
    var hoverLocked = false;

    function pad2(n) { return (n + 1 < 10 ? '0' : '') + (n + 1); }

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;

      buttons.forEach(function (btn, i) {
        var on = i === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      photos.forEach(function (img, i) {
        img.style.opacity = (i === index) ? '1' : '0';
      });

      captions.forEach(function (cap, i) {
        cap.style.opacity = (i === index) ? '1' : '0';
      });

      if (counter) counter.textContent = pad2(index);
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('mouseenter', function () {
        if (hoverLocked) return;
        setActive(i);
      });
      btn.addEventListener('focus', function () { setActive(i); });

      btn.addEventListener('click', function () {
        if (activeIndex === i) {
          var href = btn.getAttribute('data-sc-href');
          if (href && href !== '#') window.location.href = href;
          return;
        }
        setActive(i);
        hoverLocked = true;
        setTimeout(function () { hoverLocked = false; }, 400);
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var href = btn.getAttribute('data-sc-href');
          if (href && href !== '#') window.location.href = href;
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          var next = (i + 1) % buttons.length;
          buttons[next].focus();
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = (i - 1 + buttons.length) % buttons.length;
          buttons[prev].focus();
        }
      });
    });
  })();
})();
